import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FileHiddenInput, Image } from "hesus-ui-kit";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import { ColumnButton } from "@utils/extra-style";
import { documentTypeColor, documentName } from "@utils/constants";
import {
  FileInputLabel,
  FileImageWrapper,
  DocumentRow,
  FileName,
  DeleteSpan,
  DocumentDropdown,
} from "./DocumentUpload.styled";

const DocumentUploadWithType = (props) => {
  const {
    t,
    isEditMode,
    setFormData,
    formData,
    selectedProduct,
    existingDocuments,
    setExistingDocuments,
    docType,
    setDocType,
    documentTypeOptions,
    docFromLead,
  } = props;
  const fileInputRef = useRef();
  const [displayDropdown, setDisplayDropdown] = useState(false);

  const documentListRef = useRef();

  const uploadDropdownToggle = () => {
    setDisplayDropdown(!displayDropdown);
  };
  useEffect(() => {
    if (displayDropdown) {
      documentListRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [displayDropdown]);

  const triggerUploadInput = (type) => {
    fileInputRef.current.setAttribute("data-type", type);
    fileInputRef.current.click();
  };

  const onFileSelect = (e) => {
    uploadDropdownToggle();
    let filesArray = formData.documents;
    let types = docType;
    for (let i = 0; i < e.target.files.length; i++) {
      filesArray.push(e.target.files[i]);
      types.push(e.target.dataset.type);
    }
    setFormData({
      ...formData,
      documents: filesArray,
    });
    setDocType(types);
  };

  const deleteFile = (index) => {
    const fileListArr = Array.from(formData.documents);
    fileListArr.splice(index, 1); // here u remove the file

    // recreate file object
    let updatedDocs = [];
    const dT = new DataTransfer();
    if (fileListArr.length > 0) {
      for (let file of fileListArr) {
        dT.items.add(file);
      }
      updatedDocs = dT.files;
    }
    setFormData({
      ...formData,
      documents: updatedDocs,
    });

    docType.splice(index, 1); // here u remove the file
    setDocType(docType);
  };

  const deleteExistingFile = (id) => {
    const documents = existingDocuments.filter((item) => item.id !== id);
    setExistingDocuments(documents);
  };

  useEffect(() => {
    if (selectedProduct && (isEditMode || docFromLead)) {
      setExistingDocuments(selectedProduct.documents);
    }
  }, [selectedProduct, isEditMode, docFromLead]);

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            {((isEditMode && parseInt(formData.step.value, 10) === 1) ||
              !isEditMode) && (
              <Image
                className="deleteImage"
                src={deleteIcon}
                alt="delete"
                onClick={() => deleteFile(i)}
                styles={{ width: "auto" }}
              />
            )}
            <ColumnButton
              border={documentTypeColor[docType[i]]}
              background={documentTypeColor[docType[i]]}
              marginRight="10px"
              marginLeft="10px"
            >
              <span>{t(documentName[docType[i]])}</span>
            </ColumnButton>
          </DeleteSpan>{" "}
          {files[i].name}
        </FileName>
      );
    }
    return docs;
  };

  const getExistingDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            {((isEditMode && parseInt(formData?.step?.value, 10) === 1) ||
              !isEditMode) && (
              <Image
                className="deleteImage"
                src={deleteIcon}
                alt="delete"
                onClick={() => deleteExistingFile(files[i].id)}
                styles={{ width: "auto" }}
              />
            )}
            <ColumnButton
              border={documentTypeColor[files[i].type.id]}
              background={documentTypeColor[files[i].type.id]}
              marginRight="10px"
              marginLeft="10px"
            >
              <span>{t(documentName[files[i].type.id])}</span>
            </ColumnButton>
          </DeleteSpan>{" "}
          {files[i].fileName}{" "}
        </FileName>
      );
    }
    return docs;
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <FileInputLabel>{t("DOCUMENTS")}</FileInputLabel>
        {((isEditMode && parseInt(formData?.step?.value, 10) === 1) ||
          !isEditMode) && (
          <FileImageWrapper>
            <Image
              src={addIcon}
              alt="upload"
              displayDropdown={displayDropdown}
              onClick={uploadDropdownToggle}
              styles={{ width: "auto" }}
            />
          </FileImageWrapper>
        )}
        {displayDropdown && (
          <DocumentDropdown position="relative">
            <ul className="document-dropdown-list">
              {documentTypeOptions.map((item) => (
                <li
                  key={item.id}
                  className="document-upload-list-item"
                  onClick={() => triggerUploadInput(item.id)}
                >
                  <label className="document-label">{t(item.label)}</label>
                </li>
              ))}
            </ul>
            <FileHiddenInput
              type="file"
              id="document"
              inputClass="document-upload-input-field"
              onFileSelect={onFileSelect}
              fileInputRef={fileInputRef}
            />
          </DocumentDropdown>
        )}
        {/* <FileInput type="file" id="document" multiple onChange={onFileSelect} /> */}
      </div>
      {isEditMode && existingDocuments !== undefined && (
        <DocumentRow>
          {existingDocuments.length > 0 &&
            getExistingDocumentList(existingDocuments)}
          {formData.documents.length > 0
            ? getDocumentList(formData.documents)
            : ""}
        </DocumentRow>
      )}
      {!!docFromLead && !!existingDocuments && existingDocuments !== undefined && (
        <DocumentRow>
          {existingDocuments?.length > 0 &&
            getExistingDocumentList(existingDocuments)}
          {formData.documents.length > 0
            ? getDocumentList(formData.documents)
            : ""}
        </DocumentRow>
      )}
      {!isEditMode && !docFromLead && (
        <DocumentRow> {getDocumentList(formData.documents)} </DocumentRow>
      )}
      <div ref={documentListRef}></div>
    </>
  );
};

DocumentUploadWithType.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  docFromLead: PropTypes.number,
};

DocumentUploadWithType.defaultProps = {
  isEditMode: false,
  docFromLead: 0,
};

export default withTranslation()(DocumentUploadWithType);
